import { Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import FormRegistroPcd from "./components/FormRegistroPcd";
import OutlineButton from "ui/components/Button/OutlineButton";
import { BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

export default function RegistroPcd() {
  const navigate = useNavigate();

  return (
    <Flex
      py={["150px", "150px", "150px", "350px"]}
      px={["50px", "50px", "30px", "200px"]}
      gap="80px"
      flexDir="column"
    >
      <Text
        fontWeight="medium"
        fontSize="24px"
        color={colors.purple500}
        flexWrap="wrap"
        textTransform="uppercase"
      >
        Solicitação de reserva da pessoa com deficiência (Pcd)
      </Text>

      <Flex gap={10} flexDir={["column"]} align="center">
        <FormRegistroPcd />
      </Flex>

      <OutlineButton
        w="200px"
        onClick={() => navigate("/")}
        title="VOLTAR"
        color={colors.blue}
        prevIcon={<BiChevronLeft size={20} />}
      />
    </Flex>
  );
}